module.exports = __webpack_public_path__ + "img/q6.6770d298.svg";